
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { 
  Mail as EnvelopeIcon, 
  User as UserIcon, 
  Gauge as GaugeIcon, 
  ShieldCheck as ShieldCheckIcon, 
  Sparkles as SparklesIcon,
  CreditCard as CreditCardIcon
} from "lucide-react";

interface SettingsTabsProps {
  isAdmin: boolean;
}

export const SettingsTabs = ({ isAdmin }: SettingsTabsProps) => {
  return (
    <TabsList className="grid grid-cols-2 md:grid-cols-6 h-auto p-1 gap-1">
      <TabsTrigger value="email" className="py-2 flex items-center gap-2">
        <EnvelopeIcon className="h-4 w-4" />
        <span>Email</span>
      </TabsTrigger>
      <TabsTrigger value="assistants" className="py-2 flex items-center gap-2">
        <SparklesIcon className="h-4 w-4" />
        <span>Assistants</span>
      </TabsTrigger>
      <TabsTrigger value="tokens" className="py-2 flex items-center gap-2">
        <GaugeIcon className="h-4 w-4" />
        <span>Tokens</span>
      </TabsTrigger>
      <TabsTrigger value="plans" className="py-2 flex items-center gap-2">
        <CreditCardIcon className="h-4 w-4" />
        <span>Plans</span>
      </TabsTrigger>
      <TabsTrigger value="account" className="py-2 flex items-center gap-2">
        <UserIcon className="h-4 w-4" />
        <span>Account</span>
      </TabsTrigger>
      {isAdmin && (
        <TabsTrigger value="admin" className="py-2 flex items-center gap-2">
          <ShieldCheckIcon className="h-4 w-4" />
          <span>Admin</span>
        </TabsTrigger>
      )}
    </TabsList>
  );
};
